// Update contents object below
const contents = {
  header: 'Intel Corporation', //update with your client name
  logoTooltip: {
    href: 'https://www.intel.com/wonderful', //where the logo click drives to
    copy: '' // tooltip content
  },
  hero: {
    background: 'video', //options: "image" or "video"
    logoPlacement: 'top', //options: "top" or "center"
    title: 'Miller’s Landing: A Groundbreaking SmartTown Powered by Intel',
    copy:
      "How Intel is helping to build the nation's first fully connected city in an unexpected pocket of the Front Range."
  },
  inlinePhotos: {
    size: 'bodyWidth', //options: "fullBleed" or "bodyWidth"
    contents: [
      {
        class: 'photo1',
        caption:
          'A forthcoming high-tech development, Miller’s Landing, boasts frictionless connectivity while retaining the area’s natural charm. Restaurant reservations, work solutions, and even hospital visits can be managed from a smartphone thanks to Intel’s networking capabilities. '
      },
      {
        class: 'photo2',
        caption:
          'Daily conveniences can be arranged with a simple screen tap for residents and visitors, from ordering delivery to arranging transportation. Intel’s industry-leading edge technology is behind the frictionless mobile connection that makes Miller’s Landing so unique.'
      }
    ] //add more objects in the array if you have more than one photo
  },
  ctaTooltip: {
    href: 'https://sponsorcontent.cnn.com/interactive/intel/it-starts-with-intel/', //where the cta button click drives to
    copy: '' //tooltip content
  }
};

export default contents;
